import { Route } from "@angular/router";
import { LayoutComponent } from "./layout/layout.component";
import { UserGuard } from "./guards/user.guard";
import MyPageLayoutPage from "./pages/my-page/my-page-layout.page";

export const appRoutes: Route[] = [
  {
    path: "",
    component: LayoutComponent,
    children: [
      {
        path: "",
        redirectTo: "home",
        pathMatch: "full",
      },
      {
        path: "home",
        loadComponent: () => import("./pages/home/home.page"),
      },
      {
        path: "pick/:id",
        loadComponent: () =>
          import("./pages/pick/detail-pick/detail-pick.page"),
      },
      {
        path: "pick-form",
        loadComponent: () =>
          import("./pages/pick/pick-form/form/pick-form.page"),
      },
      {
        path: "pick-form/:id",
        loadComponent: () =>
          import("./pages/pick/pick-form/form/pick-form.page"),
      },
      {
        path: "policy",
        loadComponent: () => import("./layout/footer/terms/terms.component"),
      },
      {
        path: "map",
        loadComponent: () => import("./pages/map/map.page"),
      },
      {
        path: "notice",
        children: [
          {
            path: "",
            loadComponent: () => import("./pages/notice/notice.page"),
          },
          {
            path: ":id",
            loadComponent: () =>
              import("./pages/notice/detail-notice/detail-notice.page"),
          },
        ],
      },
      {
        path: "faq",
        children: [
          {
            path: "",
            loadComponent: () => import("./pages/faq/faq.page"),
          },
        ],
      },
    ],
  },
  {
    path: "my-page",
    component: MyPageLayoutPage,
    children: [
      {
        path: "info",
        title: "마이페이지",
        loadComponent: () => import("./pages/my-page/my-info/my-info.page"),
      },
      {
        path: "active",
        title: "마이페이지",
        loadComponent: () => import("./pages/my-page/my-active/my-active.page"),
      },
    ],
  },
];
